import { Component, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadingBarService, NgxLoadingBar } from '@ngx-loading-bar/core';
import {
    Router,
    NavigationStart,
    NavigationEnd,
    NavigationCancel,
    NavigationError,
} from '@angular/router';
import { filter } from 'rxjs/operators';
import { LoaderComponent } from '../shared/components/loader/loader.component';
import { TapToTopComponent } from '../shared/components/tap-to-top/tap-to-top.component';
import { AngularModule } from '../shared/angular.module';

@Component({
    selector: 'app-root',
    standalone: true,
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [AngularModule, LoaderComponent, TapToTopComponent, NgxLoadingBar],
})
export class AppComponent implements AfterViewInit {
    constructor(
        private translateService: TranslateService,
        private loadingBar: LoadingBarService,
        private router: Router,
        private cdr: ChangeDetectorRef
    ) {
        // this.loadingBar.value$.subscribe((state) =>
        //     console.log('LoadingBar state:', state)
        // );
        // Définir la langue par défaut
        this.translateService.setDefaultLang('fr');
        const lang = this.getUserLanguage();
        this.translateService.use(lang);
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.loadingBar.stop();

            this.cdr.detectChanges();
        });

        // this.loadingBar.value$.subscribe((state) => {
        //     console.log('LoadingBar state:', state);
        // });

        this.router.events
            .pipe(
                filter(
                    (event) =>
                        event instanceof NavigationStart ||
                        event instanceof NavigationEnd ||
                        event instanceof NavigationCancel ||
                        event instanceof NavigationError
                )
            )
            .subscribe((event) => {
                if (event instanceof NavigationStart) {
                    this.loadingBar.start();
                } else {
                    this.loadingBar.complete();
                }
            });
    }

    private getUserLanguage(): string {
        const browserLang = navigator.language || navigator.languages[0];
        const supported = ['en', 'fr'];
        const saved = localStorage.getItem('language');
        return saved || (supported.includes(browserLang) ? browserLang : 'fr');
    }
}
